export default "__VITE_ASSET__cMJIgSXt__"